import { useQuery } from '@tanstack/react-query';
import axios from 'axios';
import { isVersionMismatch } from 'further-ui/utils';

type Props = {
  enabled: boolean;
  refetchTime: number;
};

export const useVersionMismatchChecker = ({ enabled, refetchTime }: Props) => {
  const { data: apiVersion } = useQuery<string>({
    queryKey: ['version-check'],
    queryFn: async () => {
      const { data } = await axios.get(
        `${process.env.REACT_APP_BASEURL}version`,
      );
      return data.version;
    },
    staleTime: refetchTime - 1,
    refetchInterval: refetchTime,
    enabled,
  });

  const frontendVersion = process.env.REACT_APP_VERSION_TAG;

  return enabled && isVersionMismatch(frontendVersion, apiVersion);
};
